// Formattazione di importi in dollari. Sta qui e non dentro un componente perché serve sia allo
// store delle verifiche (che non può importare da un .vue) sia alle viste dei report.

/**
 * Importo in USD. `null`/`undefined`/non numerico → trattino.
 * I costi di una singola verifica sono spesso frazioni di centesimo, quindi il default sono 4
 * decimali: con 2 la maggior parte delle esecuzioni leggere apparirebbe come "US$ 0,00".
 */
export function formatUsd(value, digits = 4) {
  if (value === null || value === undefined) return '—'
  const n = Number(value)
  if (Number.isNaN(n)) return '—'
  return n.toLocaleString(undefined, {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  })
}

/** Come sopra ma a 2 decimali: per i totali, dove i millesimi sono rumore. */
export function formatUsdShort(value) {
  return formatUsd(value, 2)
}
